export const fullName = (user: { firstName?: string; lastName?: string; }) => `${user.firstName || ''} ${user.lastName || ''}`.trim();
